import { render, staticRenderFns } from "./TifJustificacion.vue?vue&type=template&id=78c6a0f6"
import script from "./TifJustificacion.vue?vue&type=script&lang=js"
export * from "./TifJustificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports